// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2F2qq","options":"AnswerScale_options__2ndBX","selected":"AnswerScale_selected__2q_DI"};